import { z } from 'zod';

export const committeeSchema = z.object({
  nom: z.string().min(1, 'Le nom ne doit pas être vide').max(250, 'Le nom ne doit pas dépasser 250'),
  email: z.string().email('Adresse e-mail invalide').optional().or(z.literal('')),
  theAdresse: z.object({
    email: z.string().min(1, "L'email est obligatoire").email('Adresse e-mail invalide'),
    codePostal: z.string().regex(/^\d+$/, 'Code postal doit être numérique').optional().or(z.literal('')),
  }),
});
